import { useEffect, useReducer } from 'react';
import scrollTo, { getTopOf } from '../util/scrollTo';
type RescrollFunction = (element?: Element) => unknown;
type ReducerState = {
  counter: number;
  element?: Element;
};
const reducer = (state: ReducerState, element: Element): ReducerState => {
  return {
    counter: state.counter + 1,
    element
  };
};
const useScrollTo = (elementOrValue?: Element | number, duration?: number, durationDelay?: number, deltaY?: number): RescrollFunction => {
  const [{
    counter,
    element: reducerElement
  }, rescroll] = useReducer(reducer, null, () => ({
    counter: 0
  }));
  useEffect(() => {
    if (reducerElement != null || elementOrValue != null || reducerElement != null) {
      return scrollTo(() => reducerElement != null ? getTopOf(reducerElement) + (deltaY ?? 0) : elementOrValue != null ? typeof elementOrValue === 'number' ? elementOrValue + (deltaY ?? 0) : getTopOf(elementOrValue) + (deltaY ?? 0) : deltaY ?? 0, duration, durationDelay);
    }
  }, [duration, durationDelay, elementOrValue, counter, reducerElement, deltaY]);
  return rescroll;
};
export default useScrollTo;